<template>
  <div>
    <table cellspacing="0" width="680" cellpadding="0" border="0">
      <tr>
        <td style="padding:0;vertical-align: top;" valign="top" width="80">&nbsp;</td>
        <td style="font-size:1em;padding:0;vertical-align: top;" valign="top">
          <table
            cellspacing="0"
            cellpadding="0"
            border="0"
            style="line-height: 1.4;font-family:Verdana, Geneva, sans-serif;font-size:56%;color:#666666;"
          >
            <tr>
              <td style="padding-bottom: 4px;">
                <div style="font-family:Verdana, Geneva, sans-serif;">
                  <span style="font: 600 1.35em Verdana, Geneva, sans-serif;">
                    {{
                    mainFields[0].value || ""
                    }}
                  </span>
                  <span
                    style="font: 400 1.125em Verdana, Geneva, sans-serif;"
                  >&nbsp;&minus;&nbsp;{{ mainFields[1].value || "" }}</span>
                </div>
              </td>
            </tr>
          </table>
        </td>
      </tr>
      <tr>
        <td style="line-height: 1px;" />
      </tr>
    </table>

    <table cellspacing="0" width="680" cellpadding="0" border="0">
      <tr>
        <td style="padding:0 8px 0 0;vertical-align: top;" valign="top" width="60">
          <img
            alt="ibis styles logo"
            width="60"
            style="width:60px;moz-border-radius:0%;khtml-border-radius:0%;o-border-radius:0%;webkit-border-radius:0%;ms-border-radius:0%;border-radius:0%;"
            src="https://treatec.ams3.digitaloceanspaces.com/ibis/logo_ibis_budget_combo.jpg"
          />
        </td>
        <td style="font-size:1em;padding:0 0 0 10px;vertical-align: middle;" valign="middle">
          <table
            cellspacing="0"
            cellpadding="0"
            border="0"
            style="line-height: 1.4;font-family:Verdana, Geneva, sans-serif;font-size:56%;color:#666666;"
          >
            <tr>
              <td style="padding-bottom: 4px;">
                <span
                  style="font: 600 1.35em Verdana, Geneva, sans-serif;"
                  :style="{ color: options.color.ibisBudgetMain }"
                >{{ otherFields[0].value || "" }}</span>
              </td>
            </tr>
            <tr>
              <td style="padding-bottom: 2px;">
                <span>{{ otherFields[1].value || "" }}</span>
              </td>
            </tr>
          </table>
        </td>
      </tr>
      <tr>
        <td style="line-height: 1px;" />
      </tr>
    </table>

    <table cellspacing="0" width="680" cellpadding="0" border="0">
      <tr>
        <td style="padding:4px 8px 0 0;vertical-align: top;" valign="top" width="60">
          <img
            alt="ibis styles logo"
            width="60"
            style="width:60px;moz-border-radius:0%;khtml-border-radius:0%;o-border-radius:0%;webkit-border-radius:0%;ms-border-radius:0%;border-radius:0%;"
            src="https://treatec.ams3.digitaloceanspaces.com/ibis/logo_ibis_budget_combo.jpg"
          />
        </td>
        <td style="font-size:1em;padding:0 0 0 10px;vertical-align: middle;" valign="middle">
          <table
            cellspacing="0"
            cellpadding="0"
            border="0"
            style="line-height: 1.4;font-family:Verdana, Geneva, sans-serif;font-size:56%;color:#666666;"
          >
            <tr>
              <td style="padding-bottom: 4px;">
                <span
                  style="font: 600 1.35em Verdana, Geneva, sans-serif;"
                  :style="{ color: options.color.ibisBudgetMain }"
                >{{ otherFields[2].value || "" }}</span>
              </td>
            </tr>
            <tr>
              <td style="padding-bottom: 2px;">
                <span>{{ otherFields[3].value || "" }}</span>
              </td>
            </tr>
          </table>
        </td>
      </tr>
      <tr>
        <td style="line-height: 1px;" />
      </tr>
    </table>

    <table cellspacing="0" width="680" cellpadding="0" border="0">
      <tr>
        <td style="padding:0;vertical-align: top;" valign="top" width="80">&nbsp;</td>
        <td style="font-size:1em;padding:0;vertical-align: top;" valign="top">
          <table
            cellspacing="0"
            cellpadding="0"
            border="0"
            style="line-height: 1.4;font-family:Verdana, Geneva, sans-serif;font-size:56%;color:#666666;"
          >
            <tr>
              <td style="padding-top: 4px;">
                <span style="font: 400 1em Verdana, Geneva, sans-serif;">
                  Tel. {{ otherFields[5].value || "" }} &bull; Fax
                  {{ otherFields[6].value || "" }}
                </span>
              </td>
            </tr>
            <tr>
              <td style="padding-top: 4px;">
                <a
                  style="font: 400 1.125em Verdana, Geneva, sans-serif;text-decoration:none;color:#666666;"
                  :href="`mailto:${otherFields[4].value}`"
                >{{ otherFields[4].value || "" }}</a>
              </td>
            </tr>
            <tr>
              <td style="padding-top: 8px;">
                <table cellspacing="0" cellpadding="0" border="0">
                  <tr>
                    <td style="font-family: Arial;padding: 0 4px 0 0;">
                      <a :href="formatLink(otherFields[11].value)" target="_blank">
                        <img
                          alt="facebook link"
                          style="width:20px;"
                          width="20"
                          src="https://ams3.digitaloceanspaces.com/treatec/ibis/facebook.png"
                        />
                      </a>
                    </td>
                    <td style="font-family: Arial;padding: 0 4px 0 0;">
                      <a :href="formatLink(otherFields[12].value)" target="_blank">
                        <img
                          alt="instagram link"
                          style="width:20px;"
                          width="20"
                          src="https://ams3.digitaloceanspaces.com/treatec/ibis/instagram.png"
                        />
                      </a>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td style="padding-top: 4px;">
                <div style="font-family:Verdana, Geneva, sans-serif;">
                  <a
                    style="font: 400 1.125em Verdana, Geneva, sans-serif;color:#666666!important;"
                    href="https://ibis.accorhotels.com"
                  >ibis.com</a>
                  <span
                    style="font: 400 1.125em Verdana, Geneva, sans-serif;color:#666666;"
                  >&nbsp;&bull;&nbsp;</span>
                  <a
                    style="font: 400 1.125em Verdana, Geneva, sans-serif;color:#666666!important;"
                    href="https://all.accor.com"
                  >all.accor.com</a>
                </div>
              </td>
            </tr>
            <tr>
              <td style="padding-top: 8px;">
                <span style="font: 600 1em Verdana, Geneva, sans-serif;">
                  {{
                  otherFields[7].value || ""
                  }}
                </span>
              </td>
            </tr>
            <tr>
              <td>
                <span>{{ otherFields[9].value || "" }}</span>
              </td>
            </tr>
            <tr>
              <td>
                <span>{{ otherFields[10].value || "" }}</span>
              </td>
            </tr>
            <tr>
              <td>
                <span>{{ otherFields[8].value || "" }}</span>
              </td>
            </tr>
          </table>
        </td>
      </tr>
      <tr>
        <td style="line-height: 1px;" />
      </tr>
    </table>
    <br />
    <table cellspacing="0" width="680" cellpadding="0" border="0">
      <tbody>
        <tr>
          <td style="padding:0;vertical-align: top;" valign="top">
            <img alt="accor GmbH" width="680" style="width:680px;" :src="bannerSrc.value" />
          </td>
        </tr>
        <tr>
          <td style="line-height: 1px;" />
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import EmailTemplate from "./emailTemplate";
import Avatar from "./components/Avatar";

export default {
  name: "IbisBudgetBudgetDE",

  components: {
    Avatar
  },

  extends: EmailTemplate,

  data() {
    return {
      filterFields: ["fullName", "jobTitle"]
    };
  },

  computed: {
    bannerSrc() {
      return this.banner;
    },
    otherFields() {
      if (this.isEmpty) {
        /* eslint-disable no-undef */
        return fields.basicPlaceholder.filter(
          item => !this.filterFields.includes(item.key)
        );
      }
      let arr = this.basic.fields.filter(
        item => !this.filterFields.includes(item.key) && item.value
      );

      return arr;
    },
    isCustomFieldsExist() {
      return this.otherFields.some(i => i.custom);
    }
  }
};
</script>
